import { Component, Host, h, Element, State, Prop } from '@stencil/core';

@Component({
  tag: 'uvex-newsletter-modal',
  styleUrl: 'newsletter-modal.scss',
})
export class NewsletterModal {
  @Prop() contentUrl: string;
  @Element() el!: HTMLElement;
  @State() content = '';

  delay = 90000;

  componentDidLoad() {
    if (localStorage.getItem('newsletterModal') === null) {
      const today = new Date();
      const lastShown = new Date(localStorage.getItem('newsletterModal'));
      const diff = today.getTime() - lastShown.getTime();

      // 30d = 259200000ms
      // Open newsletter modal if last shown was more than 30 days ago
      if (diff < 259200000) {
        return;
      }

      setTimeout(async () => {
        localStorage.setItem('newsletterModal', new Date().toISOString());
        this.content = await fetch(this.contentUrl).then(result => result.text());
        this.open();
      }, this.delay);
    }
  }
  open() {
    const modal = this.el.querySelector('.modal') as HTMLElement;
    const backdrop = this.el.querySelector('.modal-backdrop') as HTMLElement;
    document.body.classList.add('modal-open');
    modal.style.display = 'block';

    setTimeout(() => {
      modal.classList.add('in');
      backdrop.classList.add('in');
    });
  }

  close() {
    const modal = this.el.querySelector('.modal') as HTMLElement;
    const backdrop = this.el.querySelector('.modal-backdrop') as HTMLElement;
    setTimeout(() => {
      modal.classList.remove('in');
      backdrop.classList.remove('in');
    });
    setTimeout(() => {
      this.el.remove();
      document.body.classList.remove('modal-open');
      modal.style.display = 'none';
    }, 400);
  }

  render() {
    return (
      <Host>
        <div class="modal fade" role="dialog">
          <div class="modal-dialog modal-video modal-newsletter">
            <div class="modal-content">
              <a class="modal-close" aria-label="Close" onClick={() => this.close()}>
                <svg width="12" height="12">
                  <use href="#fa-close"></use>
                </svg>
              </a>
              <div innerHTML={this.content} />
            </div>
          </div>
        </div>
        <div class="modal-backdrop fade" />
      </Host>
    );
  }
}
